import { PortalListPresentation } from '../../presentations';

type ItemType = 'file' | 'url';
type ClientPortalItem = {
  id: number;
  title: string;
  icon_name: string;
  sort_order: number;
  item_type: ItemType;
  url: string;
};

type Args = {
  data: ClientPortalItem[];
};
type IConvertToPresentationProps = (args: Args) => {
  portalItems: React.ComponentProps<typeof PortalListPresentation>['portalItems'];
  lastSortOrder: number;
};

export const convertToPresentationProps: IConvertToPresentationProps = ({ data }) => {
  const portalItems = [...data]
    .sort((a, b) => a.sort_order - b.sort_order)
    .map(
      item =>
        ({
          id: item.id,
          iconName: item.icon_name,
          title: item.title,
          linkUrl: item.item_type === 'url' ? item.url : undefined,
          fileUrl: item.item_type === 'file' ? item.url : undefined,
          itemType: item.item_type,
          sortOrder: item.sort_order,
        }) as const
    );

  const last = portalItems[portalItems.length - 1];
  const lastSortOrder = last ? last.sortOrder : 0;

  return {
    portalItems,
    lastSortOrder,
  };
};
